module.exports = __webpack_public_path__ + "static/img/third1_4.56a2a6d1.png";